import { useContext, useEffect } from 'react'

import { Tabs } from 'antd'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-solid-svg-icons'
import { faHouseMedical } from '@fortawesome/pro-duotone-svg-icons'

import InstitutionEvaluationSummaryView from './InstitutionEvaluationSummaryView'
import Analytics from '../../../utils/analytics'
import InstitutionScoreSummaryView from './InstitutionScoreSummaryView'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { GlobalContext } from '../../../Providers/GlobalProvider'
import { InstitutionOptions } from '../../../utils/constants'

const { TabPane } = Tabs

const InstitutionEvaluationView = () => {
  const t = useSelector(selectTranslate)
  const { modules } = useContext(GlobalContext)

  useEffect(() => Analytics.pageView('/students-evaluation'), [])

  return (
    <Tabs
      defaultActiveKey='1'
      animated={false}
    >
      <TabPane
        key='1'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon
              icon={faHouseMedical}
              style={{ marginTop: '3px' }}
            />
            <div className='h-spacing' />
            {t('Institution score')}
          </div>
        }
      >
        <InstitutionScoreSummaryView />
      </TabPane>
      <TabPane
        key='2'
        tab={
          <div className='flex-row'>
            <FontAwesomeIcon icon={faUser} style={{ marginTop: '3px' }} />
            <div className='h-spacing' />
            {t('Student feedback')}
          </div>
        }
        disabled={!modules[InstitutionOptions.RECRUITMENT_MODULE]}
      >
        <InstitutionEvaluationSummaryView />
      </TabPane>
    </Tabs>
  )
}

export default InstitutionEvaluationView
